import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full bg-navy-900 overflow-hidden pt-20 pb-24 px-4 sm:px-6 lg:px-8" data-id="element-71">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-navy-800/20 -skew-x-12 transform origin-top-right translate-x-1/4 pointer-events-none" data-id="element-72" />

      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-73">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="space-y-8" data-id="element-74">
          <div className="inline-flex items-center space-x-2 bg-navy-800 border border-gold-500/30 rounded-full px-4 py-1.5" data-id="element-75">
            <span className="w-2 h-2 rounded-full bg-gold-500 animate-pulse" data-id="element-76" />
            <span className="text-gold-400 text-sm font-medium tracking-wide uppercase" data-id="element-77">
              Para compradoras latinas en USA
            </span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-cream-50 leading-tight" data-id="element-78">
            No es el down payment. <br data-id="element-79" />
            Es el <span className="text-gold-400 italic" data-id="element-80">"cash real"</span> para
            cerrar.
          </h1>

          <p className="text-lg md:text-xl text-cream-200/90 max-w-xl leading-relaxed" data-id="element-81">
            Convierte tu Loan Estimate en 3 números exactos y deja de adivinar.
            El sistema anti-ansiedad para llegar al cierre con el dinero exacto.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 pt-4" data-id="element-82">
            <a href="#pricing" onClick={e => {
            e.preventDefault();
            const target = document.getElementById('pricing');
            if (!target) return;
            const start = window.scrollY;
            const end = target.getBoundingClientRect().top + start - 40;
            const duration = 2800;
            const startTime = performance.now();
            const easeInOutCubic = (t: number) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
            const animate = (currentTime: number) => {
              const elapsed = currentTime - startTime;
              const progress = Math.min(elapsed / duration, 1);
              window.scrollTo(0, start + (end - start) * easeInOutCubic(progress));
              if (progress < 1) requestAnimationFrame(animate);
            };
            requestAnimationFrame(animate);
          }} className="inline-flex items-center justify-center px-8 py-4 text-base font-bold text-navy-900 bg-gold-500 rounded-lg hover:bg-gold-400 transition-all duration-300 shadow-[0_0_20px_rgba(201,168,76,0.3)] hover:shadow-[0_0_30px_rgba(201,168,76,0.5)] transform hover:-translate-y-1" data-id="element-83">
              Obtener el Sistema ($6.36)
              <ArrowRight className="ml-2 h-5 w-5" data-id="element-84" />
            </a>
            <p className="text-sm text-cream-200/60 flex items-center justify-center sm:justify-start mt-2 sm:mt-0 sm:ml-4" data-id="element-85">
              <CheckCircle2 className="h-4 w-4 text-gold-500 mr-2" data-id="element-86" />
              Descarga inmediata
            </p>
          </div>

          <div className="pt-8 border-t border-navy-800" data-id="element-87">
            <p className="text-sm text-cream-200/70 italic" data-id="element-88">
              "Si tu cash to close cambia, no estás loca: estás sin sistema."
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative" data-id="element-89">
          <div className="absolute inset-0 bg-gold-500/20 blur-3xl rounded-full transform translate-y-10" data-id="element-90" />
          <img src="https://cdn.magicpatterns.com/uploads/m6edm9okwdZWtRcsRtXryr/heylloyd-image-1770865285128.png" alt="Cash-to-Close Sin Ansiedad PDF en tablet" className="relative w-full h-auto rounded-xl shadow-2xl transform rotate-1 hover:rotate-0 transition-transform duration-700" data-id="element-91" />
        </motion.div>
      </div>
    </section>;
}